import React from "react";
import LineMaskHero from "../components/LineMaskHero";
import authorPhoto from "../assets/autor.jpg"; // Upewnij się, że plik istnieje w tej lokalizacji

function Home() {
  return (
    <>
      {/* Sekcja hero + nagłówek – pełna szerokość, zero marginesów i paddingu */}
      <div className="container-fluid p-0 m-0">
        <div className="text-center p-0 m-0">
          <LineMaskHero />
          
        </div>
      </div>

      {/* Sekcja ze zdjęciem (lewa kolumna) i tekstem (prawa kolumna) */}
      <div className="container-fluid p-3 m-0">
        <div className="row g-0 m-0 p-0">
          {/* Kolumna ze zdjęciem */}
          <div className="col-md-3 d-flex justify-content-center align-items-start">
            <img
              src={authorPhoto}
              alt="Liliana Kużdowicz"
              
              style={{
                width: "300px",
                height: "300px",
                objectFit: "cover",
              }}
            />
          </div>

          {/* Kolumna z tekstem */}
          <div className="col-md-9"><h2 className="m-3">Liliana Kużdowicz</h2>
            <p className="m-3">
            Absolwentka Wydziału Sztuk Pięknych Uniwersytetu Mikołaja Kopernika w Toruniu, gdzie uzyskała dyplom w pracowni graficznej prof. E. Piotrowicza. Od 1969 roku jest członkinią Związku Polskich Artystów Plastyków (ZPAP). Zajmuje się malarstwem oraz działalnością dydaktyczną.

Ma na swoim koncie dziesięć wystaw indywidualnych oraz udział w licznych ekspozycjach zbiorowych, zarówno w Polsce, jak i poza jej granicami. Prezentowała swoje prace m.in. w ramach Sztuka w stolicy – Paryż 2 (2013, Art en Capital) oraz XVIII edycji Biennale Wiosennego Art Vivant (2016, Champagne). Uczestniczyła także w licznych plenerach artystycznych i wystawach poplenerowych.

Zdobywczyni wielu nagród i wyróżnień. Jej dzieła znajdują się w zbiorach instytucji publicznych, w tym Urzędów Wojewódzkich w Krakowie i Bydgoszczy, a także w muzeach w Bydgoszczy i Chojnicach. Są również częścią prywatnych kolekcji w Polsce i za granicą.
           </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Home;
